export const coupon_zhCN = {
  'coupon.mgt.n01.lbl01': `满减券`,
  'coupon.mgt.n01.txt01': `例：满100减20元`,
  'coupon.mgt.n01.txt02': `便于合理控制活动成本`,
  'coupon.mgt.n01.lbl02': `折扣券`,
  'coupon.mgt.n01.txt03': `例：满100打9折`,
  'coupon.mgt.n01.txt04': `提高销量和客单价`,
  'coupon.mgt.n01.lbl03': `兑换券`,
  'coupon.mgt.n01.txt05': `例：用于兑换指定礼品`,
  'coupon.mgt.n01.txt06': `吸引顾客消费`,
  'coupon.mgt.n01.lbl04': `满折券`,
  'coupon.mgt.n01.txt07': `例：5件打9折`,
  'coupon.mgt.n01.txt08': `清理库存和提高销量`,

  'coupon.mgt.n02.lbl01': `名称`,
  'coupon.mgt.n02.lbl02': `类型`,
  'coupon.mgt.n02.lbl03': `适用渠道`,
  'coupon.mgt.n02.lbl04': `状态`,
  'coupon.mgt.n02.lbl05': `重置`,
  'coupon.mgt.n02.lbl06': `搜索`,
  'coupon.mgt.c01.lbl01': `优惠券ID`,
  'coupon.mgt.c01.lbl02': `优惠券名称`,
  'coupon.mgt.c01.lbl03': `名称备注`,
  'coupon.mgt.c01.lbl04': `类型`,
  'coupon.mgt.c01.lbl05': `适用渠道`,
  'coupon.mgt.c01.lbl06': `副标题`,
  'coupon.mgt.c01.lbl07': `状态`,
  'coupon.mgt.c01.lbl08': `已领取`,
  'coupon.mgt.c01.lbl09': `剩余`,
  'coupon.mgt.c01.lbl10': `有效期`,
  'coupon.mgt.c01.lbl11': `操作`,
  'coupon.mgt.c01.lbl12': `编辑`,
  'coupon.mgt.c01.lbl13': `详情`,
  'coupon.data.n01.lbl02': `优惠券`,
  'coupon.data.n01.rdo03': `类型`,
  'coupon.data.n01.rdo04': `状态`,
  'coupon.data.n01.rdo05': `会员等级`,
  'coupon.data.n01.lbl06': `手机号`,
  'coupon.data.n01.rdo07': `发券开始日期`,
  'coupon.data.n01.rdo08': `发券结束日期`,
  'coupon.data.n01.rdo09': `核销开始日期`,
  'coupon.data.n01.rdo10': `核销结束日期`,
  'coupon.data.n01.chb11': `关联公司`,
  'coupon.data.n01.chb12': '核销门店',
  'coupon.data.n01.rdo13': '获取来源',
  'coupon.data.n01.lbl14': '第三方券号',
  'coupon.data.n02.btn01': `下载`,
  'coupon.data.n02.lbl02': `筛选结果总数`,
  'coupon.data.c01.lbl01': `会员姓名`,
  'coupon.data.c01.lbl02': `会员号`,
  'coupon.data.c01.lbl03': `手机号`,
  'coupon.data.c01.lbl04': `优惠券ID`,
  'coupon.data.c01.lbl05': `优惠券名称`,
  'coupon.data.c01.lbl06': `优惠券Code`,
  'coupon.data.c01.lbl07': `获取来源`,
  'coupon.data.c01.lbl08': `发放时间`,
  'coupon.data.c01.lbl09': `优惠券状态`,
  'coupon.data.c01.lbl10': `核销时间`,
  'coupon.data.c01.lbl11': `订单编号`,
  'coupon.data.c01.lbl12': `核销门店`,
  'coupon.data.c01.lbl13': `核销渠道`,
  'coupon.writeoff.n01.rdo01': `核销开始日期`,
  'coupon.writeoff.n01.lbl02': `至`,
  'coupon.writeoff.n01.rdo03': `核销结束日期`,
  'coupon.writeoff.n01.lbl04': `会员手机号`,
  'coupon.writeoff.n01.rdo05': `发券开始日期`,
  'coupon.writeoff.n01.rdo06': `发券结束日期`,
  'coupon.writeoff.n01.lbl07': `优惠券Code`,
  'coupon.writeoff.n01.btn08': `重置`,
  'coupon.writeoff.n01.btn09': `查询`,
  'coupon.writeoff.c01.lbl01': `会员名称`,
  'coupon.writeoff.c01.lbl02': `会员编号`,
  'coupon.writeoff.c01.lbl03': `优惠券名称`,
  'coupon.writeoff.c01.lbl04': `优惠券类型`,
  'coupon.writeoff.c01.lbl05': `优惠券Code`,
  'coupon.writeoff.c01.lbl06': `优惠券ID`,
  'coupon.writeoff.c01.lbl07': `手机号`,
  'coupon.writeoff.c01.lbl08': `订单号`,
  'coupon.writeoff.c01.lbl09': `发放时间`,
  'coupon.writeoff.c01.lbl10': `领取时间`,
  'coupon.writeoff.c01.lbl11': `核销时间`,
  'coupon.writeoff.c01.lbl12': `核销渠道`,
  'coupon.writeoff.d01.lbl01': `交易详情`,
  'coupon.writeoff.d01.lbl02': `订单编号`,
  'coupon.writeoff.d01.lbl03': `交易门店ID`,
  'coupon.writeoff.d01.lbl04': `交易门店名称`,
  'coupon.writeoff.d01.lbl05': `所属分公司`,
  'coupon.writeoff.d01.lbl06': `订单类型`,
  'coupon.writeoff.d01.lbl07': `订单来源`,
  'coupon.writeoff.d01.lbl08': `支付方式`,
  'coupon.writeoff.d01.lbl09': `下单时间`,
  'coupon.writeoff.d01.lbl10': `订单金额`,
  'coupon.writeoff.d01.lbl11': `实付金额`,
  'coupon.data.n01.lbl01': `优惠券ID`,

  'voucher.mgt.n01.lbl01': `满减券`,
  'voucher.mgt.n01.txt02': `例：满100减20元`,
  'voucher.mgt.n01.lbl03': `折扣券`,
  'voucher.mgt.n01.txt04': `例：满100打9折`,
  'voucher.mgt.n01.lbl05': `兑换券`,
  'voucher.mgt.n01.txt06': `例：用于兑换指定礼品`,
  'voucher.mgt.n01.lbl07': `满折券`,
  'voucher.mgt.n01.txt08': `例：5件打9折`,
  'voucher.mgt.n02.lbl01': `名称`,
  'voucher.mgt.n02.lbl02': `类型`,
  'voucher.mgt.n02.lbl03': `适用渠道`,
  'voucher.mgt.n02.lbl04': `状态`,
  'voucher.mgt.n02.lbl05': `重置`,
  'voucher.mgt.n02.lbl06': `搜索`,
  'voucher.mgt.c01.lbl01': `优惠券ID`,
  'voucher.mgt.c01.lbl02': `优惠券名称`,
  'voucher.mgt.c01.lbl03': `名称备注`,
  'voucher.mgt.c01.lbl04': `类型`,
  'voucher.mgt.c01.lbl05': `适用渠道`,
  'voucher.mgt.c01.lbl06': `副标题`,
  'voucher.mgt.c01.lbl07': `状态`,
  'voucher.mgt.c01.lbl08': `已领取`,
  'voucher.mgt.c01.lbl09': `剩余`,
  'voucher.mgt.c01.lbl10': `有效期`,
  'voucher.mgt.c01.lbl11': `操作`,
  'voucher.mgt.c01.lbl12': `编辑`,
  'voucher.mgt.c01.lbl13': `详情`,
  'voucher.mgt.volume.n01.lbl01': `基本设置`,
  'voucher.mgt.volume.n01.lbl02': `优惠券名称`,
  'voucher.mgt.volume.n01.placeholder03': `请输入优惠券名称`,
  'voucher.mgt.volume.n01.lbl04': `优惠券副标题`,
  'voucher.mgt.volume.n01.placeholder05': `请输入优惠券副标题`,
  'voucher.mgt.volume.n01.lbl06': `优惠券备注`,
  'voucher.mgt.volume.n01.placeholder07': `请输入优惠券备注`,
  'voucher.mgt.volume.n01.lbl08': `发放总量`,
  'voucher.mgt.volume.n01.placeholder09': `请输入发放总量`,
  'voucher.mgt.volume.n01.rdo10': `使用门槛`,
  'voucher.mgt.volume.n01.lbl11': `无使用门槛`,
  'voucher.mgt.volume.n01.lbl12': `订单满`,
  'voucher.mgt.volume.n01.lbl13': `优惠内容`,
  'voucher.mgt.volume.n01.lbl14': `减免`,
  'voucher.mgt.volume.n01.txt15': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'voucher.mgt.volume.n01.lbl16': `用券时间`,
  'voucher.mgt.volume.n01.rdo17': `开始日期`,
  'voucher.mgt.volume.n01.rdo18': `结束日期`,
  'voucher.mgt.volume.n01.chb19': `领券`,
  'voucher.mgt.volume.n01.lbl20': `领取和使用规则`,
  'voucher.mgt.volume.n01.rdo21': `领取人限制`,
  'voucher.mgt.volume.n01.lbl22': `不限制，所有人可领`,
  'voucher.mgt.volume.n01.lbl23': `指定用户身份可领（仅会员）`,
  'voucher.mgt.volume.n01.rdo24': `每人限领次数`,
  'voucher.mgt.volume.n01.lbl25': `不限次数`,
  'voucher.mgt.volume.n01.lbl26': `限`,
  'voucher.mgt.volume.n01.chb27': `分享设置`,
  'voucher.mgt.volume.n01.lbl28': `优惠券允许分享给好友领取`,
  'voucher.mgt.volume.n01.chb29': `转赠设置`,
  'voucher.mgt.volume.n01.lbl30': `优惠券允许转增给好友`,
  'voucher.mgt.volume.n01.chb31': `使用条件`,
  'voucher.mgt.volume.n01.lbl32': `不可与其他优惠券叠加使用`,
  'voucher.mgt.volume.n01.lbl33': `不可会员优惠同享`,
  'voucher.mgt.volume.n01.lbl34': `不可店铺促销同享`,
  'voucher.mgt.volume.n01.lbl35': `不可非正价商品同享`,
  'voucher.mgt.volume.n01.lbl36': `员工券`,
  'voucher.mgt.volume.n01.lbl37': `使用此券消费金额可累计消费积分`,
  'voucher.mgt.volume.n01.lbl38': `使用此券消费金额可算升级`,
  'voucher.mgt.volume.n01.lbl39': `限制订单内商品件数`,
  'voucher.mgt.volume.n01.lbl40': `使用说明`,
  'voucher.mgt.volume.n02.lbl01': `渠道设置`,
  'voucher.mgt.volume.n02.chb02': `适用渠道`,
  'voucher.mgt.volume.n02.lbl03': `官网`,
  'voucher.mgt.volume.n02.lbl04': `爱步官网小程序`,
  'voucher.mgt.volume.n02.lbl05': `线下渠道`,
  'voucher.mgt.volume.n02.rdo06': `适用公司`,
  'voucher.mgt.volume.n02.lbl07': `全部公司`,
  'voucher.mgt.volume.n02.rdo08': `指定公司`,
  'voucher.mgt.volume.n02.rdo09': `适用门店`,
  'voucher.mgt.volume.n02.lbl10': `全部门店`,
  'voucher.mgt.volume.n02.lbl11': `指定门店`,
  'voucher.mgt.volume.n03.lbl01': `商品设置`,
  'voucher.mgt.volume.n03.rdo02': `适用商品`,
  'voucher.mgt.volume.n03.lbl03': `全部商品`,
  'voucher.mgt.volume.n03.lbl04': `适用商品`,
  'voucher.mgt.volume.n04.lbl01': `同步设置`,
  'voucher.mgt.volume.n04.lbl02': `微信卡券同步设置`,
  'voucher.mgt.volume.n04.lbl03': `微信卡券`,
  'voucher.mgt.volume.n04.chb04': `领取后可同步至微信卡包`,
  'voucher.mgt.volume.n04.rdo05': `选择模板`,
  'voucher.mgt.volume.n04.lbl06': `适用商品范围`,
  'voucher.mgt.volume.n04.placeholder07': `如：双十一优惠券，最多20字`,
  'voucher.mgt.pricevalue.n01.lbl01': `基本设置`,
  'voucher.mgt.pricevalue.n01.lbl02': `优惠券名称`,
  'voucher.mgt.pricevalue.n01.placeholder03': `请输入优惠券名称`,
  'voucher.mgt.pricevalue.n01.lbl04': `优惠券副标题`,
  'voucher.mgt.pricevalue.n01.placeholder05': `请输入优惠券副标题`,
  'voucher.mgt.pricevalue.n01.lbl06': `优惠券备注`,
  'voucher.mgt.pricevalue.n01.placeholder07': `请输入优惠券备注`,
  'voucher.mgt.pricevalue.n01.lbl08': `发放总量`,
  'voucher.mgt.pricevalue.n01.placeholder09': `请输入发放总量`,
  'voucher.mgt.pricevalue.n01.rdo10': `使用门槛`,
  'voucher.mgt.pricevalue.n01.lbl11': `无使用门槛`,
  'voucher.mgt.pricevalue.n01.lbl12': `折扣比例`,
  'voucher.mgt.pricevalue.n01.lbl13': `（原价为1,0.88即为八八折）`,
  'voucher.mgt.pricevalue.n01.txt14': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'voucher.mgt.pricevalue.n01.lbl15': `用券时间`,
  'voucher.mgt.pricevalue.n01.rdo16': `开始日期`,
  'voucher.mgt.pricevalue.n01.rdo17': `结束日期`,
  'voucher.mgt.pricevalue.n01.chb18': `领券`,
  'voucher.mgt.pricevalue.n01.lbl19': `领取和使用规则`,
  'voucher.mgt.pricevalue.n01.rdo20': `领取人限制`,
  'voucher.mgt.pricevalue.n01.lbl21': `不限制，所有人可领`,
  'voucher.mgt.pricevalue.n01.lbl22': `指定用户身份可领（仅会员）`,
  'voucher.mgt.pricevalue.n01.rdo23': `每人限领次数`,
  'voucher.mgt.pricevalue.n01.lbl24': `不限次数`,
  'voucher.mgt.pricevalue.n01.lbl25': `限`,
  'voucher.mgt.pricevalue.n01.lbl26': `次`,
  'voucher.mgt.pricevalue.n01.chb27': `分享设置`,
  'voucher.mgt.pricevalue.n01.lbl28': `优惠券允许分享给好友领取`,
  'voucher.mgt.pricevalue.n01.chb29': `转赠设置`,
  'voucher.mgt.pricevalue.n01.lbl30': `优惠券允许转增给好友`,
  'voucher.mgt.pricevalue.n01.chb31': `使用条件`,
  'voucher.mgt.pricevalue.n01.lbl32': `不可与其他优惠券叠加使用`,
  'voucher.mgt.pricevalue.n01.lbl33': `不可会员优惠同享`,
  'voucher.mgt.pricevalue.n01.lbl34': `不可店铺促销同享`,
  'voucher.mgt.pricevalue.n01.lbl35': `不可非正价商品同享`,
  'voucher.mgt.pricevalue.n01.lbl36': `员工券`,
  'voucher.mgt.pricevalue.n01.lbl37': `使用此券消费金额可累计消费积分`,
  'voucher.mgt.pricevalue.n01.lbl38': `使用此券消费金额可算升级`,
  'voucher.mgt.pricevalue.n01.lbl39': `限制订单内商品件数`,
  'voucher.mgt.pricevalue.n01.lbl40': `件`,
  'voucher.mgt.pricevalue.n01.lbl41': `使用说明`,
  'voucher.mgt.pricevalue.n01.txt42': `优惠券名称是必填项`,
  'voucher.mgt.pricevalue.n01.txt43': `优惠券副标题是必填项`,
  'voucher.mgt.pricevalue.n01.txt44': `发放总量是必填项`,
  'voucher.mgt.pricevalue.n01.txt45': `金额是必填项`,
  'voucher.mgt.pricevalue.n01.txt46': `内可用`,
  'voucher.mgt.pricevalue.n01.txt47': `优惠减免是必填项`,
  'voucher.mgt.pricevalue.n01.txt48': `满足件数是必填项`,
  'voucher.mgt.pricevalue.n01.txt49': `请输入折扣比例`,
  'voucher.mgt.pricevalue.n01.txt50': `折扣比例是必填项`,
  'voucher.mgt.pricevalue.n01.txt51': `折扣比例不得大于1`,
  'voucher.mgt.pricevalue.n01.txt52': `填写商品描述`,
  'voucher.mgt.pricevalue.n01.txt53': `商品描述必填项`,
  'voucher.mgt.pricevalue.n01.txt54': `用券时间是必选项`,
  'voucher.mgt.pricevalue.n01.txt55': `当日`,
  'voucher.mgt.pricevalue.n01.txt56': `次日`,
  'voucher.mgt.pricevalue.n01.txt57': `起`,
  'voucher.mgt.pricevalue.n01.txt58': `天数是必填项`,
  'voucher.mgt.pricevalue.n01.txt59': `每人限领次数是必填项`,
  'voucher.mgt.pricevalue.n01.txt60': `如果不限制商品件数，输入0`,
  'voucher.mgt.pricevalue.n01.txt61': `填写优惠券的具体使用信息`,
  'voucher.mgt.pricevalue.n01.txt62': `使用说明是必填项`,
  'voucher.mgt.pricevalue.n01.txt63': `门店Code`,
  'voucher.mgt.pricevalue.n01.txt64': `门店名称`,
  'voucher.mgt.pricevalue.n01.txt65': `操作`,
  'voucher.mgt.pricevalue.n01.txt66': `选择门店`,
  'voucher.mgt.pricevalue.n01.txt67': `选择不可用门店`,
  'voucher.mgt.pricevalue.n01.txt68': `请输入门店名称`,
  'voucher.mgt.pricevalue.n01.txt69': `适用渠道至少选择一项`,
  'voucher.mgt.pricevalue.n01.txt70': `公司名称`,
  'voucher.mgt.pricevalue.n01.txt71': `请选择公司`,
  'voucher.mgt.pricevalue.n01.txt72': `请添加适用门店`,
  'voucher.mgt.pricevalue.n01.txt73': `可用门店`,
  'voucher.mgt.pricevalue.n01.txt74': `不可用门店`,
  'voucher.mgt.pricevalue.n01.txt75': `添加`,
  'voucher.mgt.pricevalue.n01.txt76': `共`,
  'voucher.mgt.pricevalue.n01.txt77': `编码`,
  'voucher.mgt.pricevalue.n01.txt78': `名称`,
  'voucher.mgt.pricevalue.n01.txt79': `内容`,
  'voucher.mgt.pricevalue.n01.txt80': `类型`,
  'voucher.mgt.pricevalue.n01.txt81': `款号`,
  'voucher.mgt.pricevalue.n01.txt82': `货号`,
  'voucher.mgt.pricevalue.n01.txt83': `系列`,
  'voucher.mgt.pricevalue.n01.txt84': `全球季节`,
  'voucher.mgt.pricevalue.n01.txt85': `品类`,
  'voucher.mgt.pricevalue.n01.txt86': `大类`,
  'voucher.mgt.pricevalue.n01.txt87': `请输入款号名称`,
  'voucher.mgt.pricevalue.n01.txt88': `请输入货号名称`,
  'voucher.mgt.pricevalue.n01.txt89': `请输入商品名称`,
  'voucher.mgt.pricevalue.n01.txt90': `请输入系列名称`,
  'voucher.mgt.pricevalue.n01.txt91': `请输入全球季节名称`,
  'voucher.mgt.pricevalue.n01.txt92': `请输入品类名称`,
  'voucher.mgt.pricevalue.n01.txt93': `请输入大类名称`,
  'voucher.mgt.pricevalue.n01.txt94': `请输入款号名称`,
  'voucher.mgt.pricevalue.n01.txt95': `请输入系列名称`,
  'voucher.mgt.pricevalue.n01.txt96': `请输入配件种类名称`,
  'voucher.mgt.pricevalue.n01.txt97': `请添加适用商品`,
  'voucher.mgt.pricevalue.n01.txt98': `可用商品`,
  'voucher.mgt.pricevalue.n01.txt99': `第`,
  'voucher.mgt.pricevalue.n01.txt100': `不可用商品`,
  'voucher.mgt.pricevalue.n01.txt101': `请选择模板`,
  'voucher.mgt.pricevalue.n02.lbl01': `渠道设置`,
  'voucher.mgt.pricevalue.n02.chb02': `适用渠道`,
  'voucher.mgt.pricevalue.n02.lbl03': `官网`,
  'voucher.mgt.pricevalue.n02.lbl04': `爱步官网小程序`,
  'voucher.mgt.pricevalue.n02.lbl05': `线下渠道`,
  'voucher.mgt.pricevalue.n02.rdo06': `适用公司`,
  'voucher.mgt.pricevalue.n02.lbl07': `全部公司`,
  'voucher.mgt.pricevalue.n02.rdo08': `指定公司`,
  'voucher.mgt.pricevalue.n02.rdo09': `适用门店`,
  'voucher.mgt.pricevalue.n02.lbl10': `全部门店`,
  'voucher.mgt.pricevalue.n02.lbl11': `指定门店`,
  'voucher.mgt.pricevalue.n03.lbl01': `商品设置`,
  'voucher.mgt.pricevalue.n03.rdo02': `适用商品`,
  'voucher.mgt.pricevalue.n03.lbl03': `全部商品`,
  'voucher.mgt.pricevalue.n03.lbl04': `适用商品`,
  'voucher.mgt.pricevalue.n04.lbl01': `同步设置`,
  'voucher.mgt.pricevalue.n04.lbl02': `微信卡券同步设置`,
  'voucher.mgt.pricevalue.n04.lbl03': `微信卡券`,
  'voucher.mgt.pricevalue.n04.chb04': `领取后可同步至微信卡包`,
  'voucher.mgt.pricevalue.n04.rdo05': `选择模板`,
  'voucher.mgt.pricevalue.n04.lbl06': `适用商品范围`,
  'voucher.mgt.pricevalue.n04.placeholder07': `如：双十一优惠券，最多20字`,
  'voucher.mgt.exchange.n01.lbl01': `基本设置`,
  'voucher.mgt.exchange.n01.lbl02': `优惠券名称`,
  'voucher.mgt.exchange.n01.placeholder03': `请输入优惠券名称`,
  'voucher.mgt.exchange.n01.lbl04': `优惠券副标题`,
  'voucher.mgt.exchange.n01.placeholder05': `请输入优惠券副标题`,
  'voucher.mgt.exchange.n01.lbl06': `优惠券备注`,
  'voucher.mgt.exchange.n01.placeholder07': `请输入优惠券备注`,
  'voucher.mgt.exchange.n01.lbl08': `发放总量`,
  'voucher.mgt.exchange.n01.placeholder09': `请输入发放总量`,
  'voucher.mgt.exchange.n01.rdo10': `使用门槛`,
  'voucher.mgt.exchange.n01.lbl11': `无使用门槛`,
  'voucher.mgt.exchange.n01.lbl12': `商品描述`,
  'voucher.mgt.exchange.n01.txt13': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'voucher.mgt.exchange.n01.lbl14': `用券时间`,
  'voucher.mgt.exchange.n01.rdo15': `开始日期`,
  'voucher.mgt.exchange.n01.rdo16': `结束日期`,
  'voucher.mgt.exchange.n01.chb17': `领券`,
  'voucher.mgt.exchange.n01.lbl18': `领取和使用规则`,
  'voucher.mgt.exchange.n01.rdo19': `领取人限制`,
  'voucher.mgt.exchange.n01.lbl20': `不限制，所有人可领`,
  'voucher.mgt.exchange.n01.lbl21': `指定用户身份可领（仅会员）`,
  'voucher.mgt.exchange.n01.rdo22': `每人限领次数`,
  'voucher.mgt.exchange.n01.lbl23': `不限次数`,
  'voucher.mgt.exchange.n01.lbl24': `限`,
  'voucher.mgt.exchange.n01.chb25': `分享设置`,
  'voucher.mgt.exchange.n01.lbl26': `优惠券允许分享给好友领取`,
  'voucher.mgt.exchange.n01.chb27': `转赠设置`,
  'voucher.mgt.exchange.n01.lbl28': `优惠券允许转增给好友`,
  'voucher.mgt.exchange.n01.chb29': `使用条件`,
  'voucher.mgt.exchange.n01.lbl30': `不可与其他优惠券叠加使用`,
  'voucher.mgt.exchange.n01.lbl31': `不可会员优惠同享`,
  'voucher.mgt.exchange.n01.lbl32': `不可店铺促销同享`,
  'voucher.mgt.exchange.n01.lbl33': `不可非正价商品同享`,
  'voucher.mgt.exchange.n01.lbl34': `员工券`,
  'voucher.mgt.exchange.n01.lbl35': `使用此券消费金额可累计消费积分`,
  'voucher.mgt.exchange.n01.lbl36': `使用此券消费金额可算升级`,
  'voucher.mgt.exchange.n01.lbl37': `限制订单内商品件数`,
  'voucher.mgt.exchange.n01.lbl38': `使用说明`,
  'voucher.mgt.exchange.n02.lbl01': `渠道设置`,
  'voucher.mgt.exchange.n02.chb02': `适用渠道`,
  'voucher.mgt.exchange.n02.lbl03': `官网`,
  'voucher.mgt.exchange.n02.lbl04': `爱步官网小程序`,
  'voucher.mgt.exchange.n02.lbl05': `线下渠道`,
  'voucher.mgt.exchange.n02.rdo06': `适用公司`,
  'voucher.mgt.exchange.n02.lbl07': `全部公司`,
  'voucher.mgt.exchange.n02.rdo08': `指定公司`,
  'voucher.mgt.exchange.n02.rdo09': `适用门店`,
  'voucher.mgt.exchange.n02.lbl10': `全部门店`,
  'voucher.mgt.exchange.n02.lbl11': `指定门店`,
  'voucher.mgt.exchange.n03.lbl01': `商品设置`,
  'voucher.mgt.exchange.n03.rdo02': `适用商品`,
  'voucher.mgt.exchange.n03.lbl03': `全部商品`,
  'voucher.mgt.exchange.n03.lbl04': `适用商品`,
  'voucher.mgt.exchange.n04.lbl01': `同步设置`,
  'voucher.mgt.exchange.n04.lbl02': `微信卡券同步设置`,
  'voucher.mgt.exchange.n04.lbl03': `微信卡券`,
  'voucher.mgt.exchange.n04.chb04': `领取后可同步至微信卡包`,
  'voucher.mgt.exchange.n04.rdo05': `选择模板`,
  'voucher.mgt.exchange.n04.lbl06': `适用商品范围`,
  'voucher.mgt.exchange.n04.placeholder07': `如：双十一优惠券，最多20字`,
  'voucher.mgt.pricequantity.n01.lbl01': `基本设置`,
  'voucher.mgt.pricequantity.n01.lbl02': `优惠券名称`,
  'voucher.mgt.pricequantity.n01.placeholder03': `请输入优惠券名称`,
  'voucher.mgt.pricequantity.n01.lbl04': `优惠券副标题`,
  'voucher.mgt.pricequantity.n01.placeholder05': `请输入优惠券副标题`,
  'voucher.mgt.pricequantity.n01.lbl06': `优惠券备注`,
  'voucher.mgt.pricequantity.n01.placeholder07': `请输入优惠券备注`,
  'voucher.mgt.pricequantity.n01.lbl08': `发放总量`,
  'voucher.mgt.pricequantity.n01.placeholder09': `请输入发放总量`,
  'voucher.mgt.pricequantity.n01.rdo10': `使用门槛`,
  'voucher.mgt.pricequantity.n01.lbl11': `无使用门槛`,
  'voucher.mgt.pricequantity.n01.lbl12': `满足件数`,
  'voucher.mgt.pricequantity.n01.lbl13': `请输入满足件数`,
  'voucher.mgt.pricequantity.n01.lbl14': `折扣比例`,
  'voucher.mgt.pricequantity.n01.lbl15': `（原价为1,0.88即为八八折）`,
  'voucher.mgt.pricequantity.n01.txt16': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'voucher.mgt.pricequantity.n01.lbl17': `用券时间`,
  'voucher.mgt.pricequantity.n01.rdo18': `开始日期`,
  'voucher.mgt.pricequantity.n01.rdo19': `结束日期`,
  'voucher.mgt.pricequantity.n01.chb20': `领券`,
  'voucher.mgt.pricequantity.n01.lbl21': `天内可用`,
  'voucher.mgt.pricequantity.n01.lbl22': `领取和使用规则`,
  'voucher.mgt.pricequantity.n01.rdo23': `领取人限制`,
  'voucher.mgt.pricequantity.n01.lbl24': `不限制，所有人可领`,
  'voucher.mgt.pricequantity.n01.lbl25': `指定用户身份可领（仅会员）`,
  'voucher.mgt.pricequantity.n01.rdo26': `每人限领次数`,
  'voucher.mgt.pricequantity.n01.lbl27': `不限次数`,
  'voucher.mgt.pricequantity.n01.lbl28': `限`,
  'voucher.mgt.pricequantity.n01.lbl29': `次`,
  'voucher.mgt.pricequantity.n01.chb30': `分享设置`,
  'voucher.mgt.pricequantity.n01.lbl31': `优惠券允许分享给好友领取`,
  'voucher.mgt.pricequantity.n01.chb32': `转赠设置`,
  'voucher.mgt.pricequantity.n01.lbl33': `优惠券允许转增给好友`,
  'voucher.mgt.pricequantity.n01.chb34': `使用条件`,
  'voucher.mgt.pricequantity.n01.lbl35': `不可与其他优惠券叠加使用`,
  'voucher.mgt.pricequantity.n01.lbl36': `不可会员优惠同享`,
  'voucher.mgt.pricequantity.n01.lbl37': `不可店铺促销同享`,
  'voucher.mgt.pricequantity.n01.lbl38': `不可非正价商品同享`,
  'voucher.mgt.pricequantity.n01.lbl39': `员工券`,
  'voucher.mgt.pricequantity.n01.lbl40': `使用此券消费金额可累计消费积分`,
  'voucher.mgt.pricequantity.n01.lbl41': `使用此券消费金额可算升级`,
  'voucher.mgt.pricequantity.n01.lbl42': `限制订单内商品件数`,
  'voucher.mgt.pricequantity.n01.lbl43': `件`,
  'voucher.mgt.pricequantity.n01.lbl44': `使用说明`,
  'voucher.mgt.pricequantity.n02.chb02': `适用渠道`,
  'voucher.mgt.pricequantity.n02.lbl03': `官网`,
  'voucher.mgt.pricequantity.n02.lbl04': `爱步官网小程序`,
  'voucher.mgt.pricequantity.n02.lbl05': `线下渠道`,
  'voucher.mgt.pricequantity.n02.rdo06': `适用公司`,
  'voucher.mgt.pricequantity.n02.lbl07': `全部公司`,
  'voucher.mgt.pricequantity.n02.rdo08': `指定公司`,
  'voucher.mgt.pricequantity.n02.rdo09': `适用门店`,
  'voucher.mgt.pricequantity.n02.lbl10': `全部门店`,
  'voucher.mgt.pricequantity.n02.lbl11': `指定门店`,
  'voucher.mgt.pricequantity.n03.lbl01': `商品设置`,
  'voucher.mgt.pricequantity.n03.rdo02': `适用商品`,
  'voucher.mgt.pricequantity.n03.lbl03': `全部商品`,
  'voucher.mgt.pricequantity.n03.lbl04': `适用商品`,
  'voucher.mgt.pricequantity.n04.lbl01': `同步设置`,
  'voucher.mgt.pricequantity.n04.lbl02': `微信卡券同步设置`,
  'voucher.mgt.pricequantity.n04.lbl03': `微信卡券`,
  'voucher.mgt.pricequantity.n04.chb04': `领取后可同步至微信卡包`,
  'voucher.mgt.pricequantity.n04.rdo05': `选择模板`,
  'voucher.mgt.pricequantity.n04.lbl06': `适用商品范围`,
  'voucher.mgt.pricequantity.n04.placeholder07': `如：双十一优惠券，最多20字`,
};
export const coupon_enUS = {
  'coupon.mgt.n01.lbl01': `VOLUME DISCOUNT COUPON`, //满减券
  'coupon.mgt.n01.txt01': `APPLIES A VOLUME DISCOUNT`, //例：满100减20元
  'coupon.mgt.n01.txt02': `ONCE A CUSTOMER REACHES A CERTAIN AMOUNT OF SALES VOLUME`, //便于合理控制活动成本
  'coupon.mgt.n01.lbl02': `PRICE-BREAK DISCOUNT COUPON(VALUE)`, //折扣券
  'coupon.mgt.n01.txt03': `APPLIES A PRICE-BREAK DISCOUNT`, //例：满100打9折
  'coupon.mgt.n01.txt04': `ONCE A CUSTOMER REACHES A CERTAIN AMOUNT OF SALES VOLUME`, //提高销量和客单价
  'coupon.mgt.n01.lbl03': `EXCHANGE COUPON`, //兑换券
  'coupon.mgt.n01.txt05': `APPLIES SPECIFIC ITEMS EXCHANGING`, //例：用于兑换指定礼品
  'coupon.mgt.n01.txt06': `FOR ATTRACTING CONSUMERS.`, //吸引顾客消费
  'coupon.mgt.n01.lbl04': `PRICE-BREAK DISCOUNT COUPON(QUANTITY)`, //满折券
  'coupon.mgt.n01.txt07': `APPLIES A PRICE-BREAK DISCOUNT.`, //例：5件打9折
  'coupon.mgt.n01.txt08': `ONCE A CUSTOMER REACHES A CERTAIN QUANTITY OF SALES.`, //清理库存和提高销量
  'coupon.mgt.n02.lbl01': `NAME`,
  'coupon.mgt.n02.lbl02': `TYPE`,
  'coupon.mgt.n02.lbl03': `SOURCE`,
  'coupon.mgt.n02.lbl04': `STATUS`,
  'coupon.mgt.n02.lbl05': `RESET`,
  'coupon.mgt.n02.lbl06': `SEARCH`,
  'coupon.mgt.c01.lbl01': `VOUCHER ID`,
  'coupon.mgt.c01.lbl02': `VOUCHER NAME`,
  'coupon.mgt.c01.lbl03': `NAME REMARK`,
  'coupon.mgt.c01.lbl04': `TYPE`,
  'coupon.mgt.c01.lbl05': `SOURCE`,
  'coupon.mgt.c01.lbl06': `SUB TITLE`,
  'coupon.mgt.c01.lbl07': `STATUS`,
  'coupon.mgt.c01.lbl08': `RECEIVED`,
  'coupon.mgt.c01.lbl09': `REMAINING`,
  'coupon.mgt.c01.lbl10': `VALID PERIOD`,
  'coupon.mgt.c01.lbl11': `ACTIVE`,
  'coupon.mgt.c01.lbl12': `EDIT`,
  'coupon.mgt.c01.lbl13': `DETAIL`,
  'coupon.data.n01.lbl01': `VOUCHER ID`,
  'coupon.data.n01.lbl02': `VOUCHER NAME`,
  'coupon.data.n01.rdo03': `TYPE`,
  'coupon.data.n01.rdo04': `STATUS`,
  'coupon.data.n01.rdo05': `RANK`,
  'coupon.data.n01.lbl06': `MP NUMBER`,
  'coupon.data.n01.rdo07': `START OF DATE OF ISSUE`,
  'coupon.data.n01.rdo08': `END OF DATE OF ISSUE`,
  'coupon.data.n01.rdo09': `START OF DATE OF WRITE OFF`,
  'coupon.data.n01.rdo10': `END OF DATE OF WRITE OFF`,
  'coupon.data.n01.chb11': `Related Company`,
  'coupon.data.n01.chb12': 'Store of Write Off',
  'coupon.data.n01.rdo13': 'Received Source',
  'coupon.data.n01.lbl14': 'Third Party Coupon ID',
  'coupon.data.n02.btn01': `DOWNLOAD`,
  'coupon.data.n02.lbl02': `FILTER RESULTS AMOUNT`,
  'coupon.data.c01.lbl01': `MEMBER NAME`,
  'coupon.data.c01.lbl02': `MEMBER ID`,
  'coupon.data.c01.lbl03': `MP NUMBER`,
  'coupon.data.c01.lbl04': `VOUCHER ID`,
  'coupon.data.c01.lbl05': `VOUCHER NAME`,
  'coupon.data.c01.lbl06': `VOUCHER CODE`,
  'coupon.data.c01.lbl07': `RECEIVED SOURCE`,
  'coupon.data.c01.lbl08': `ISSUE TIME`,
  'coupon.data.c01.lbl09': `Coupon Status`,
  'coupon.data.c01.lbl10': `Time of Write Off`,
  'coupon.data.c01.lbl11': `Order ID`,
  'coupon.data.c01.lbl12': `Store of Write Off`,
  'coupon.data.c01.lbl13': `Source of Write Off`,
  'coupon.writeoff.n01.rdo01': `START OF DATE OF WRITE OFF`,
  'coupon.writeoff.n01.lbl02': `TO`,
  'coupon.writeoff.n01.rdo03': `END OF DATE OF WRITE OFF`,
  'coupon.writeoff.n01.lbl04': `MEMBER MP NUMBER`,
  'coupon.writeoff.n01.rdo05': `START OF DATE OF ISSUE`,
  'coupon.writeoff.n01.rdo06': `END OF DATE OF ISSUE`,
  'coupon.writeoff.n01.lbl07': `VOUCHER CODE`,
  'coupon.writeoff.n01.btn08': `RESET`,
  'coupon.writeoff.n01.btn09': `SEARCH`,
  'coupon.writeoff.c01.lbl01': `MEMBER NAME`,
  'coupon.writeoff.c01.lbl02': `MEMBER ID`,
  'coupon.writeoff.c01.lbl03': `VOUCHER NAME`,
  'coupon.writeoff.c01.lbl04': `VOUCHER TYPE`,
  'coupon.writeoff.c01.lbl05': `VOUCHER CODE`,
  'coupon.writeoff.c01.lbl06': `VOUCHER ID`,
  'coupon.writeoff.c01.lbl07': `MP NUMBER`,
  'coupon.writeoff.c01.lbl08': `ORDER NUMBER`,
  'coupon.writeoff.c01.lbl09': `TIME OF ISSUE`,
  'coupon.writeoff.c01.lbl10': `TIME OF RECEIVE`,
  'coupon.writeoff.c01.lbl11': `TIME OF WRITE OFF`,
  'coupon.writeoff.c01.lbl12': `SOURCE OF WRITE OFF`,
  'coupon.writeoff.d01.lbl01': `ORDER DETAIL`,
  'coupon.writeoff.d01.lbl02': `ORDER ID`,
  'coupon.writeoff.d01.lbl03': `STORE ID`,
  'coupon.writeoff.d01.lbl04': `STORE NAME`,
  'coupon.writeoff.d01.lbl05': `SUBSIDIARY`,
  'coupon.writeoff.d01.lbl06': `ORDER TYPE`,
  'coupon.writeoff.d01.lbl07': `ORDER SOURCE`,
  'coupon.writeoff.d01.lbl08': `PAYMENT METHOD`,
  'coupon.writeoff.d01.lbl09': `ORDER TIME`,
  'coupon.writeoff.d01.lbl10': `ORDER AMOUNT`,
  'coupon.writeoff.d01.lbl11': `ACTUALLY PAID`,

  'voucher.mgt.volume.n01.lbl01': `BASIC OPTION`,
  'voucher.mgt.volume.n01.lbl02': `VOUCHER NAME`,
  'voucher.mgt.volume.n01.placeholder03': `PLEASE ENTER VOUCHER NAME`,
  'voucher.mgt.volume.n01.lbl04': `VOUCHER SUB-TITLE`,
  'voucher.mgt.volume.n01.placeholder05': `PLEASE ENTER VOUCHER SUB-TITLE`,
  'voucher.mgt.volume.n01.lbl06': `VOUCHER REMARK`,
  'voucher.mgt.volume.n01.placeholder07': `PLEASE ENTER VOUCHER REMARK`,
  'voucher.mgt.volume.n01.lbl08': `AMOUNT OF ISSUE`,
  'voucher.mgt.volume.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`,
  'voucher.mgt.volume.n01.rdo10': `AVAILABLE CONDITION`,
  'voucher.mgt.volume.n01.lbl11': `ALL CONDITION`,
  'voucher.mgt.volume.n01.lbl12': `NEEDING AN ORDER REACHES`,
  'voucher.mgt.volume.n01.lbl13': `VOUCHER DETAILS`,
  'voucher.mgt.volume.n01.lbl14': `DISCOUNT VALUES`,
  'voucher.mgt.volume.n01.txt15': `VOUCHER DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`,
  'voucher.mgt.volume.n01.lbl16': `VALID TIME`,
  'voucher.mgt.volume.n01.rdo17': `FROM`,
  'voucher.mgt.volume.n01.rdo18': `END`,
  'voucher.mgt.volume.n01.chb19': `CAN BE USED IN`,
  'voucher.mgt.volume.n01.lbl20': `RULES`,
  'voucher.mgt.volume.n01.rdo21': `WHO CAN RECEIVE`,
  'voucher.mgt.volume.n01.lbl22': `ALL PEOPLE`,
  'voucher.mgt.volume.n01.lbl23': `ONLY MEMBERS`,
  'voucher.mgt.volume.n01.rdo24': `TIMES CAN MEMBERS RECEIVED`,
  'voucher.mgt.volume.n01.lbl25': `NO LIMIT`,
  'voucher.mgt.volume.n01.lbl26': `LIMITED FOR`,
  'voucher.mgt.volume.n01.chb27': `SHARING OPTION`,
  'voucher.mgt.volume.n01.lbl28': `ALLOWED TO SHARE TO FRIENDS`,
  'voucher.mgt.volume.n01.chb29': `GIVING OPTION`,
  'voucher.mgt.volume.n01.lbl30': `ALLOWED TO GIVE TO FRIENDS`,
  'voucher.mgt.volume.n01.chb31': `LIMIT CONDITIONS`,
  'voucher.mgt.volume.n01.lbl32': `NOT ALLOWED WITH OTHER VOUCHER`,
  'voucher.mgt.volume.n01.lbl33': `NOT ALLOWED WITH MEMBER DISCOUNT`,
  'voucher.mgt.volume.n01.lbl34': `NOT ALLOWED WITH STORE DISCOUNT`,
  'voucher.mgt.volume.n01.lbl35': `NOT ALLOWED WITH ITEM DISCOUNT`,
  'voucher.mgt.volume.n01.lbl36': `VOUCHER FOR STAFF`,
  'voucher.mgt.volume.n01.lbl37': `CALCULATED IN POINTS`,
  'voucher.mgt.volume.n01.lbl38': `CALCULATED IN RANK`,
  'voucher.mgt.volume.n01.lbl39': `LIMITED `,
  'voucher.mgt.volume.n01.lbl40': `EXPLANATION`,
  'voucher.mgt.volume.n02.lbl01': `SOURCE OPTION`,
  'voucher.mgt.volume.n02.chb02': `SOURCE OF USING`,
  'voucher.mgt.volume.n02.lbl03': `OFFICIAL`,
  'voucher.mgt.volume.n02.lbl04': `APPLETS`,
  'voucher.mgt.volume.n02.lbl05': `OFFLINE`,
  'voucher.mgt.volume.n02.rdo06': `WHICH COMPANY TO USE`,
  'voucher.mgt.volume.n02.lbl07': `ALL`,
  'voucher.mgt.volume.n02.rdo08': `ONLY CAN USED IN`,
  'voucher.mgt.volume.n02.rdo09': `WHICH STORE TO USE`,
  'voucher.mgt.volume.n02.lbl10': `ALL`,
  'voucher.mgt.volume.n02.lbl11': `ONLY CAN USED IN`,
  'voucher.mgt.volume.n03.lbl01': `ITEM OPTION`,
  'voucher.mgt.volume.n03.rdo02': `WHICH ITEM TO USE`,
  'voucher.mgt.volume.n03.lbl03': `ONLY CAN USED IN`,
  'voucher.mgt.volume.n03.lbl04': `ITEM OPTION`,
  'voucher.mgt.volume.n04.lbl01': `SYNCHRONIZING OPTION`,
  'voucher.mgt.volume.n04.lbl02': `WECHAT VOUCHER SYNCHRONIZING OPTION`,
  'voucher.mgt.volume.n04.lbl03': `WECHAT WALLET`,
  'voucher.mgt.volume.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`,
  'voucher.mgt.volume.n04.rdo05': `CHOOSE TEMPLET`,
  'voucher.mgt.volume.n04.lbl06': `ONLY CAN USED IN`,
  'voucher.mgt.volume.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 VOUCHER.UP TO 20 WORDS.`,
  'voucher.mgt.pricevalue.n01.lbl01': `BASIC OPTION`,
  'voucher.mgt.pricevalue.n01.lbl02': `VOUCHER NAME`,
  'voucher.mgt.pricevalue.n01.placeholder03': `PLEASE ENTER VOUCHER NAME`,
  'voucher.mgt.pricevalue.n01.lbl04': `VOUCHER SUB-TITLE`,
  'voucher.mgt.pricevalue.n01.placeholder05': `PLEASE ENTER VOUCHER SUB-TITLE`,
  'voucher.mgt.pricevalue.n01.lbl06': `VOUCHER REMARK`,
  'voucher.mgt.pricevalue.n01.placeholder07': `PLEASE ENTER VOUCHER REMARK`,
  'voucher.mgt.pricevalue.n01.lbl08': `AMOUNT OF ISSUE`,
  'voucher.mgt.pricevalue.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`,
  'voucher.mgt.pricevalue.n01.rdo10': `AVAILABLE CONDITION`,
  'voucher.mgt.pricevalue.n01.lbl11': `ALL CONDITION`,
  'voucher.mgt.pricevalue.n01.lbl12': `DISCOUNT PERCENTAGE`,
  'voucher.mgt.pricevalue.n01.lbl13': `1 MEANS NO DISCOUNT,0.88 MEANS 12% DISCOUNT`,
  'voucher.mgt.pricevalue.n01.txt14': `VOUCHER DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`,
  'voucher.mgt.pricevalue.n01.lbl15': `VALID TIME`,
  'voucher.mgt.pricevalue.n01.rdo16': `FROM`,
  'voucher.mgt.pricevalue.n01.rdo17': `END`,
  'voucher.mgt.pricevalue.n01.chb18': `CAN BE USED IN`,
  'voucher.mgt.pricevalue.n01.lbl19': `RULES`,
  'voucher.mgt.pricevalue.n01.rdo20': `WHO CAN RECEIVE`,
  'voucher.mgt.pricevalue.n01.lbl21': `ALL PEOPLE`,
  'voucher.mgt.pricevalue.n01.lbl22': `ONLY MEMBERS`,
  'voucher.mgt.pricevalue.n01.rdo23': `TIMES CAN MEMBERS RECEIVED`,
  'voucher.mgt.pricevalue.n01.lbl24': `NO LIMIT`,
  'voucher.mgt.pricevalue.n01.lbl25': `LIMITED FOR`,
  'voucher.mgt.pricevalue.n01.lbl26': `TIMES`, //次
  'voucher.mgt.pricevalue.n01.chb27': `SHARING OPTION`,
  'voucher.mgt.pricevalue.n01.lbl28': `ALLOWED TO SHARE TO FRIENDS`,
  'voucher.mgt.pricevalue.n01.chb29': `GIVING OPTION`,
  'voucher.mgt.pricevalue.n01.lbl30': `ALLOWED TO GIVE TO FRIENDS`,
  'voucher.mgt.pricevalue.n01.chb31': `LIMIT CONDITIONS`,
  'voucher.mgt.pricevalue.n01.lbl32': `NOT ALLOWED WITH OTHER VOUCHER`,
  'voucher.mgt.pricevalue.n01.lbl33': `NOT ALLOWED WITH MEMBER DISCOUNT`,
  'voucher.mgt.pricevalue.n01.lbl34': `NOT ALLOWED WITH STORE DISCOUNT`,
  'voucher.mgt.pricevalue.n01.lbl35': `NOT ALLOWED WITH ITEM DISCOUNT`,
  'voucher.mgt.pricevalue.n01.lbl36': `VOUCHER FOR STAFF`,
  'voucher.mgt.pricevalue.n01.lbl37': `CALCULATED IN POINTS`,
  'voucher.mgt.pricevalue.n01.lbl38': `CALCULATED IN RANK`,
  'voucher.mgt.pricevalue.n01.lbl39': `LIMITED `,
  'voucher.mgt.pricevalue.n01.lbl40': `PIECES`, //件
  'voucher.mgt.pricevalue.n01.lbl41': `EXPLANATION`,
  'voucher.mgt.pricevalue.n01.txt42': `COUPON NAME IS MANDATORY`, //优惠券名称是必填项
  'voucher.mgt.pricevalue.n01.txt43': `COUPON SUBHEADINGS ARE MANDATORY`, //优惠券副标题是必填项
  'voucher.mgt.pricevalue.n01.txt44': `PARAMETER IS MANDATORY`, //发放总量是必填项
  'voucher.mgt.pricevalue.n01.txt45': `AMOUNT IS MANDATORY`, //金额是必填项
  'voucher.mgt.pricevalue.n01.txt46': `AVAILABLE WITHIN`, //内可用
  'voucher.mgt.pricevalue.n01.txt47': `DISCOUNT OR EXEMPTION IS MANDATORY`, //优惠减免是必填项
  'voucher.mgt.pricevalue.n01.txt48': `PARAMETER IS MANDATORY`, //满足件数是必填项
  'voucher.mgt.pricevalue.n01.txt49': `PLEASE ENTER THE DISCOUNT RATE`, //请输入折扣比例
  'voucher.mgt.pricevalue.n01.txt50': `DISCOUNT RATE IS MANDATORY`, //折扣比例是必填项
  'voucher.mgt.pricevalue.n01.txt51': `THE DISCOUNT RATIO SHOULD NOT EXCEED 1`, //折扣比例不得大于1
  'voucher.mgt.pricevalue.n01.txt52': `FILL IN THE PRODUCT DESCRIPTION`, //填写商品描述
  'voucher.mgt.pricevalue.n01.txt53': `PRODUCT DESCRIPTION THIS PARAMETER IS MANDATORY`, //商品描述必填项
  'voucher.mgt.pricevalue.n01.txt54': `COUPON TIME IS MANDATORY`, //用券时间是必选项
  'voucher.mgt.pricevalue.n01.txt55': `ON THE DAY`, //当日
  'voucher.mgt.pricevalue.n01.txt56': `THE NEXT DAY`, //次日
  'voucher.mgt.pricevalue.n01.txt57': `SINCE`, //起
  'voucher.mgt.pricevalue.n01.txt58': `NUMBER OF DAYS IS MANDATORY`, //天数是必填项
  'voucher.mgt.pricevalue.n01.txt59': `LIMIT NUMBER OF TIMES PER PERSON IS MANDATORY`, //每人限领次数是必填项
  'voucher.mgt.pricevalue.n01.txt60': `IF THE NUMBER OF ITEMS IS NOT LIMITED, ENTER 0`, //如果不限制商品件数，输入0
  'voucher.mgt.pricevalue.n01.txt61': `FILL IN THE SPECIFIC USAGE INFORMATION OF THE COUPON`, //填写优惠券的具体使用信息
  'voucher.mgt.pricevalue.n01.txt62': `INSTRUCTIONS ARE MANDATORY`, //使用说明是必填项
  'voucher.mgt.pricevalue.n01.txt63': `STORE CODE`, //门店Code
  'voucher.mgt.pricevalue.n01.txt64': `STORE NAME`, //门店名称
  'voucher.mgt.pricevalue.n01.txt65': `ACTIVE`, //操作
  'voucher.mgt.pricevalue.n01.txt66': `SELECT STORES`, //选择门店
  'voucher.mgt.pricevalue.n01.txt67': `SELECT UNAVAILABLE STORES`, //选择不可用门店
  'voucher.mgt.pricevalue.n01.txt68': `PLEASE ENTER THE STORE NAME`, //请输入门店名称
  'voucher.mgt.pricevalue.n01.txt69': `SELECT AT LEAST ONE APPLICABLE CHANNEL`, //适用渠道至少选择一项
  'voucher.mgt.pricevalue.n01.txt70': `COMPANY NAME`, //公司名称
  'voucher.mgt.pricevalue.n01.txt71': `PLEASE SELECT COMPANY`, //请选择公司
  'voucher.mgt.pricevalue.n01.txt72': `PLEASE ADD APPLICABLE STORES`, //请添加适用门店
  'voucher.mgt.pricevalue.n01.txt73': `AVAILABLE STORES`, //可用门店
  'voucher.mgt.pricevalue.n01.txt74': `UNAVAILABLE STORE`, //不可用门店
  'voucher.mgt.pricevalue.n01.txt75': `ADD`, //添加
  'voucher.mgt.pricevalue.n01.txt76': `A TOTAL OF`, //共
  'voucher.mgt.pricevalue.n01.txt77': `CODING`, //编码
  'voucher.mgt.pricevalue.n01.txt78': `NAME`, //名称
  'voucher.mgt.pricevalue.n01.txt79': `CONTENT`, //内容
  'voucher.mgt.pricevalue.n01.txt80': `TYPE`, //类型
  'voucher.mgt.pricevalue.n01.txt81': `MODEL NO.`, //款号
  'voucher.mgt.pricevalue.n01.txt82': `ARTICLE NUMBER`, //货号
  'voucher.mgt.pricevalue.n01.txt83': `SERIES`, //系列
  'voucher.mgt.pricevalue.n01.txt84': `GLOBAL SEASON`, //全球季节
  'voucher.mgt.pricevalue.n01.txt85': `CATEGORY`, //品类
  'voucher.mgt.pricevalue.n01.txt86': `CATEGORIES`, //大类
  'voucher.mgt.pricevalue.n01.txt87': `PLEASE ENTER THE PAYMENT CODE NAME`, //请输入款号名称
  'voucher.mgt.pricevalue.n01.txt88': `PLEASE ENTER THE ARTICLE NUMBER`, //请输入货号名称
  'voucher.mgt.pricevalue.n01.txt89': `PLEASE ENTER THE NAME OF THE PRODUCT`, //请输入商品名称
  'voucher.mgt.pricevalue.n01.txt90': `PLEASE ENTER A SERIES NAME`, //请输入系列名称
  'voucher.mgt.pricevalue.n01.txt91': `PLEASE ENTER A GLOBAL SEASON NAME`, //请输入全球季节名称
  'voucher.mgt.pricevalue.n01.txt92': `PLEASE ENTER CATEGORY NAME`, //请输入品类名称
  'voucher.mgt.pricevalue.n01.txt93': `PLEASE ENTER A CATEGORY NAME`, //请输入大类名称
  'voucher.mgt.pricevalue.n01.txt94': `PLEASE ENTER THE PAYMENT CODE NAME`, //请输入款号名称
  'voucher.mgt.pricevalue.n01.txt95': `PLEASE ENTER A SERIES NAME`, //请输入系列名称
  'voucher.mgt.pricevalue.n01.txt96': `PLEASE ENTER THE NAME OF THE ACCESSORY TYPE`, //请输入配件种类名称
  'voucher.mgt.pricevalue.n01.txt97': `PLEASE ADD THE APPLICABLE PRODUCT`, //请添加适用商品
  'voucher.mgt.pricevalue.n01.txt98': `THE AVAILABLE GOODS`, //可用商品
  'voucher.mgt.pricevalue.n01.txt99': `THE`, //第
  'voucher.mgt.pricevalue.n01.txt100': `UNUSABLE GOODS`, //不可用商品
  'voucher.mgt.pricevalue.n01.txt101': `PLEASE SELECT TEMPLATE`, //请选择模板
  'voucher.mgt.pricevalue.n02.lbl01': `SOURCE OPTION`,
  'voucher.mgt.pricevalue.n02.chb02': `SOURCE OF USING`,
  'voucher.mgt.pricevalue.n02.lbl03': `OFFICIAL`,
  'voucher.mgt.pricevalue.n02.lbl04': `APPLETS`,
  'voucher.mgt.pricevalue.n02.lbl05': `OFFLINE`,
  'voucher.mgt.pricevalue.n02.rdo06': `WHICH COMPANY TO USE`,
  'voucher.mgt.pricevalue.n02.lbl07': `ALL`,
  'voucher.mgt.pricevalue.n02.rdo08': `ONLY CAN USED IN`,
  'voucher.mgt.pricevalue.n02.rdo09': `WHICH STORE TO USE`,
  'voucher.mgt.pricevalue.n02.lbl10': `ALL`,
  'voucher.mgt.pricevalue.n02.lbl11': `ONLY CAN USED IN`,
  'voucher.mgt.pricevalue.n03.lbl01': `ITEM OPTION`,
  'voucher.mgt.pricevalue.n03.rdo02': `WHICH ITEM TO USE`,
  'voucher.mgt.pricevalue.n03.lbl03': `ONLY CAN USED IN`,
  'voucher.mgt.pricevalue.n03.lbl04': `ITEM OPTION`,
  'voucher.mgt.pricevalue.n04.lbl01': `SYNCHRONIZING OPTION`,
  'voucher.mgt.pricevalue.n04.lbl02': `WECHAT VOUCHER SYNCHRONIZING OPTION`,
  'voucher.mgt.pricevalue.n04.lbl03': `WECHAT WALLET`,
  'voucher.mgt.pricevalue.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`,
  'voucher.mgt.pricevalue.n04.rdo05': `CHOOSE TEMPLET`,
  'voucher.mgt.pricevalue.n04.lbl06': `ONLY CAN USED IN`,
  'voucher.mgt.pricevalue.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 VOUCHER.UP TO 20 WORDS.`,
  'voucher.mgt.exchange.n01.lbl01': `BASIC OPTION`,
  'voucher.mgt.exchange.n01.lbl02': `VOUCHER NAME`,
  'voucher.mgt.exchange.n01.placeholder03': `PLEASE ENTER VOUCHER NAME`,
  'voucher.mgt.exchange.n01.lbl04': `VOUCHER SUB-TITLE`,
  'voucher.mgt.exchange.n01.placeholder05': `PLEASE ENTER VOUCHER SUB-TITLE`,
  'voucher.mgt.exchange.n01.lbl06': `VOUCHER REMARK`,
  'voucher.mgt.exchange.n01.placeholder07': `PLEASE ENTER VOUCHER REMARK`,
  'voucher.mgt.exchange.n01.lbl08': `AMOUNT OF ISSUE`,
  'voucher.mgt.exchange.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`,
  'voucher.mgt.exchange.n01.rdo10': `AVAILABLE CONDITION`,
  'voucher.mgt.exchange.n01.lbl11': `ALL CONDITION`,
  'voucher.mgt.exchange.n01.lbl12': `ITEM DESCRIPTION`,
  'voucher.mgt.exchange.n01.txt13': `VOUCHER DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`,
  'voucher.mgt.exchange.n01.lbl14': `VALID TIME`,
  'voucher.mgt.exchange.n01.rdo15': `FROM`,
  'voucher.mgt.exchange.n01.rdo16': `END`,
  'voucher.mgt.exchange.n01.chb17': `CAN BE USED IN`,
  'voucher.mgt.exchange.n01.lbl18': `RULES`,
  'voucher.mgt.exchange.n01.rdo19': `WHO CAN RECEIVE`,
  'voucher.mgt.exchange.n01.lbl20': `ALL PEOPLE`,
  'voucher.mgt.exchange.n01.lbl21': `ONLY MEMBERS`,
  'voucher.mgt.exchange.n01.rdo22': `TIMES CAN MEMBERS RECEIVED`,
  'voucher.mgt.exchange.n01.lbl23': `NO LIMIT`,
  'voucher.mgt.exchange.n01.lbl24': `LIMITED FOR`,
  'voucher.mgt.exchange.n01.chb25': `SHARING OPTION`,
  'voucher.mgt.exchange.n01.lbl26': `ALLOWED TO SHARE TO FRIENDS`,
  'voucher.mgt.exchange.n01.chb27': `GIVING OPTION`,
  'voucher.mgt.exchange.n01.lbl28': `ALLOWED TO GIVE TO FRIENDS`,
  'voucher.mgt.exchange.n01.chb29': `LIMIT CONDITIONS`,
  'voucher.mgt.exchange.n01.lbl30': `NOT ALLOWED WITH OTHER VOUCHER`,
  'voucher.mgt.exchange.n01.lbl31': `NOT ALLOWED WITH MEMBER DISCOUNT`,
  'voucher.mgt.exchange.n01.lbl32': `NOT ALLOWED WITH STORE DISCOUNT`,
  'voucher.mgt.exchange.n01.lbl33': `NOT ALLOWED WITH ITEM DISCOUNT`,
  'voucher.mgt.exchange.n01.lbl34': `VOUCHER FOR STAFF`,
  'voucher.mgt.exchange.n01.lbl35': `CALCULATED IN POINTS`,
  'voucher.mgt.exchange.n01.lbl36': `CALCULATED IN RANK`,
  'voucher.mgt.exchange.n01.lbl37': `LIMITED `,
  'voucher.mgt.exchange.n01.lbl38': `EXPLANATION`,
  'voucher.mgt.exchange.n02.lbl01': `SOURCE OPTION`,
  'voucher.mgt.exchange.n02.chb02': `SOURCE OF USING`,
  'voucher.mgt.exchange.n02.lbl03': `OFFICIAL`,
  'voucher.mgt.exchange.n02.lbl04': `APPLETS`,
  'voucher.mgt.exchange.n02.lbl05': `OFFLINE`,
  'voucher.mgt.exchange.n02.rdo06': `WHICH COMPANY TO USE`,
  'voucher.mgt.exchange.n02.lbl07': `ALL`,
  'voucher.mgt.exchange.n02.rdo08': `ONLY CAN USED IN`,
  'voucher.mgt.exchange.n02.rdo09': `WHICH STORE TO USE`,
  'voucher.mgt.exchange.n02.lbl10': `ALL`,
  'voucher.mgt.exchange.n02.lbl11': `ONLY CAN USED IN`,
  'voucher.mgt.exchange.n03.lbl01': `ITEM OPTION`,
  'voucher.mgt.exchange.n03.rdo02': `WHICH ITEM TO USE`,
  'voucher.mgt.exchange.n03.lbl03': `ONLY CAN USED IN`,
  'voucher.mgt.exchange.n03.lbl04': `ITEM OPTION`,
  'voucher.mgt.exchange.n04.lbl01': `SYNCHRONIZING OPTION`,
  'voucher.mgt.exchange.n04.lbl02': `WECHAT VOUCHER SYNCHRONIZING OPTION`,
  'voucher.mgt.exchange.n04.lbl03': `WECHAT WALLET`,
  'voucher.mgt.exchange.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`,
  'voucher.mgt.exchange.n04.rdo05': `CHOOSE TEMPLET`,
  'voucher.mgt.exchange.n04.lbl06': `ONLY CAN USED IN`,
  'voucher.mgt.exchange.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 VOUCHER.UP TO 20 WORDS.`,
  'voucher.mgt.pricequantity.n01.lbl01': `BASIC OPTION`,
  'voucher.mgt.pricequantity.n01.lbl02': `VOUCHER NAME`,
  'voucher.mgt.pricequantity.n01.placeholder03': `PLEASE ENTER VOUCHER NAME`,
  'voucher.mgt.pricequantity.n01.lbl04': `VOUCHER SUB-TITLE`,
  'voucher.mgt.pricequantity.n01.placeholder05': `PLEASE ENTER VOUCHER SUB-TITLE`,
  'voucher.mgt.pricequantity.n01.lbl06': `VOUCHER REMARK`,
  'voucher.mgt.pricequantity.n01.placeholder07': `PLEASE ENTER VOUCHER REMARK`,
  'voucher.mgt.pricequantity.n01.lbl08': `AMOUNT OF ISSUE`,
  'voucher.mgt.pricequantity.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`,
  'voucher.mgt.pricequantity.n01.rdo10': `AVAILABLE CONDITION`,
  'voucher.mgt.pricequantity.n01.lbl11': `ALL CONDITION`,
  'voucher.mgt.pricequantity.n01.lbl12': `NEEDING AN ORDER REACHES VALUES OF`,
  'voucher.mgt.pricequantity.n01.lbl13': `PLEASE ENTER AMOUNT OF ITEMS`,
  'voucher.mgt.pricequantity.n01.lbl14': `DISCOUNT PERCENTAGE`,
  'voucher.mgt.pricequantity.n01.lbl15': `1 MEANS 0% OFF,0.88 MEANS 12% OFF`,
  'voucher.mgt.pricequantity.n01.txt16': `VOUCHER DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`,
  'voucher.mgt.pricequantity.n01.lbl17': `VALID TIME`,
  'voucher.mgt.pricequantity.n01.rdo18': `FROM`,
  'voucher.mgt.pricequantity.n01.rdo19': `END`,
  'voucher.mgt.pricequantity.n01.chb20': `CAN BE USED IN`,
  'voucher.mgt.pricequantity.n01.lbl21': `DAYS`,
  'voucher.mgt.pricequantity.n01.lbl22': `RULES`,
  'voucher.mgt.pricequantity.n01.rdo23': `WHO CAN RECEIVE`,
  'voucher.mgt.pricequantity.n01.lbl24': `ALL PEOPLE`,
  'voucher.mgt.pricequantity.n01.lbl25': `ONLY MEMBERS`,
  'voucher.mgt.pricequantity.n01.rdo26': `TIMES CAN MEMBERS RECEIVED`,
  'voucher.mgt.pricequantity.n01.lbl27': `NO LIMIT`,
  'voucher.mgt.pricequantity.n01.lbl28': `LIMITED FOR`,
  'voucher.mgt.pricequantity.n01.lbl29': `TIMES`,
  'voucher.mgt.pricequantity.n01.chb30': `SHARING OPTION`,
  'voucher.mgt.pricequantity.n01.lbl31': `ALLOWED TO SHARE TO FRIENDS`,
  'voucher.mgt.pricequantity.n01.chb32': `GIVING OPTION`,
  'voucher.mgt.pricequantity.n01.lbl33': `ALLOWED TO GIVE TO FRIENDS`,
  'voucher.mgt.pricequantity.n01.chb34': `LIMIT CONDITIONS`,
  'voucher.mgt.pricequantity.n01.lbl35': `NOT ALLOWED WITH OTHER VOUCHER`,
  'voucher.mgt.pricequantity.n01.lbl36': `NOT ALLOWED WITH MEMBER DISCOUNT`,
  'voucher.mgt.pricequantity.n01.lbl37': `NOT ALLOWED WITH STORE DISCOUNT`,
  'voucher.mgt.pricequantity.n01.lbl38': `NOT ALLOWED WITH ITEM DISCOUNT`,
  'voucher.mgt.pricequantity.n01.lbl39': `VOUCHER FOR STAFF`,
  'voucher.mgt.pricequantity.n01.lbl40': `CALCULATED IN POINTS`,
  'voucher.mgt.pricequantity.n01.lbl41': `CALCULATED IN RANK`,
  'voucher.mgt.pricequantity.n01.lbl42': `LIMITED `,
  'voucher.mgt.pricequantity.n01.lbl43': `PIECES OF ITEM IN AN ORDER`,
  'voucher.mgt.pricequantity.n01.lbl44': `EXPLANATION`,
  'voucher.mgt.pricequantity.n02.chb02': `SOURCE OF USING`,
  'voucher.mgt.pricequantity.n02.lbl03': `OFFICIAL`,
  'voucher.mgt.pricequantity.n02.lbl04': `APPLETS`,
  'voucher.mgt.pricequantity.n02.lbl05': `OFFLINE`,
  'voucher.mgt.pricequantity.n02.rdo06': `WHICH COMPANY TO USE`,
  'voucher.mgt.pricequantity.n02.lbl07': `ALL`,
  'voucher.mgt.pricequantity.n02.rdo08': `ONLY CAN USED IN`,
  'voucher.mgt.pricequantity.n02.rdo09': `WHICH STORE TO USE`,
  'voucher.mgt.pricequantity.n02.lbl10': `ALL`,
  'voucher.mgt.pricequantity.n02.lbl11': `ONLY CAN USED IN`,
  'voucher.mgt.pricequantity.n03.lbl01': `ITEM OPTION`,
  'voucher.mgt.pricequantity.n03.rdo02': `WHICH ITEM TO USE`,
  'voucher.mgt.pricequantity.n03.lbl03': `ONLY CAN USED IN`,
  'voucher.mgt.pricequantity.n03.lbl04': `ITEM OPTION`,
  'voucher.mgt.pricequantity.n04.lbl01': `SYNCHRONIZING OPTION`,
  'voucher.mgt.pricequantity.n04.lbl02': `WECHAT VOUCHER SYNCHRONIZING OPTION`,
  'voucher.mgt.pricequantity.n04.lbl03': `WECHAT WALLET`,
  'voucher.mgt.pricequantity.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`,
  'voucher.mgt.pricequantity.n04.rdo05': `CHOOSE TEMPLET`,
  'voucher.mgt.pricequantity.n04.lbl06': `ONLY CAN USED IN`,
  'voucher.mgt.pricequantity.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 VOUCHER.UP TO 20 WORDS.`,
};
